import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/images/logo.png';

function LandingPageHeader(props) {
  return (
    <header className={props.class} data-version={process.env.REACT_APP_VERSION} data-build={process.env.REACT_APP_BUILD_DATE}>
      <div className="container-fluid header-con">
        <div className="container">
          <div className="row">
            <div className="row col-lg-12 d-flex">
              <div className="logo-con col-lg-5">
                <Link to="/">
                  <img alt="logo img" src={logo} height="100" />
                </Link>
              </div>
              {props.header && (
                <div className="col-lg-7 mt-2">
                  <span className="header-text">
                    {props.header}
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default LandingPageHeader;
